export default "__VITE_ASSET__DpwSANER__"